<div class="section-card" #exportRef>
  <div class="section-header">
    <span class="section-title">Venta semanal</span>
    <div class="export-actions">
      <button class="export-btn" (click)="exportar('png')" title="Exportar imagen">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
        IMG
      </button>
      <button class="export-btn" (click)="exportar('pdf')" title="Exportar PDF">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
        PDF
      </button>
    </div>
  </div>
  <div class="week-item" *ngFor="let s of semanas; let i = index">
    <div class="week-color-bar" [style.background]="s.pct >= 0 ? '#22c55e' : '#f87171'"></div>
    <div class="week-info">
      <div class="week-label">{{ s.label }}</div>
      <div class="week-value">{{ formatShort(s.totalPesos) }}</div>
      <div class="week-kg">{{ formatMoney(s.totalKg) }} Kg</div>
    </div>
    <div class="week-pct">
      <span [class.pos]="s.pct > 0" [class.neg]="s.pct < 0">
        {{ s.pct > 0 ? '▲' : s.pct < 0 ? '▼' : '—' }} {{ s.pct !== 0 ? s.pct + '%' : '' }}
      </span>
      <span class="pct-kg" [class.pos]="s.pctKg > 0" [class.neg]="s.pctKg < 0">
        {{ s.pctKg > 0 ? '▲' : s.pctKg < 0 ? '▼' : '—' }} {{ s.pctKg !== 0 ? s.pctKg + '% Kg' : '' }}
      </span>
    </div>
  </div>
</div>
